/* @flow */
import cx from 'classnames';
import * as React from 'react';
import Text from 'components/Text';
import Glyph from 'components/Glyph';
import ReactionPickerTrigger from 'chat/components/ReactionPickerTrigger';
import { getUniqueUsers } from 'chat/lib/reactionsCopyHelper';

import './styles/ReactionStatus.scss';

type Props = {
  sentBySelf?: boolean,
  addReactionToSummary: Function,
  removeReactionFromSummary: Function,
  reactionSummary: ?ReactionSummaryGQL,
};

function hasNoReactions(reactionSummary: ?ReactionSummaryGQL) {
  return !reactionSummary || reactionSummary.reactions.length <= 0;
}

class ReactionStatus extends React.Component<Props> {
  render() {
    const { reactionSummary, sentBySelf } = this.props;
    const noReactions = hasNoReactions(reactionSummary);

    if (sentBySelf && noReactions) {
      return null;
    }

    // This can be caused by hermes timeouts. Since we have no useful information to show, just abort
    // https://app.asana.com/0/32507888495125/395443531020487
    if (!noReactions && reactionSummary && getUniqueUsers(reactionSummary).length === 0) {
      return null;
    }

    if (noReactions) {
      return (
        <div className={cx('ReactionStatus', { 'ReactionStatus-nullState': noReactions })}>
          <ReactionPickerTrigger
            alignment="left"
            className="ReactionStatus-info"
            addReactionToSummary={this.props.addReactionToSummary}
            removeReactionFromSummary={this.props.removeReactionFromSummary}>
            <Glyph className="ReactionStatus-info-glyph" name="reaction-smiley" size="large" />
            <Text className="ReactionStatus-info-text" size="xxxsmall">
              Be the first to leave a reaction
            </Text>
            <div className="ReactionStatus-info-spacer" />
          </ReactionPickerTrigger>
        </div>
      );
    }

    return null;
  }
}

export default ReactionStatus;
